/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Whatsapp_Enabled_LabelInputs */

const he_account_delivery_whatsapp_enabled_label = /** @type {(inputs: Account_Delivery_Whatsapp_Enabled_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראות בווטסאפ`)
};

const en_account_delivery_whatsapp_enabled_label = /** @type {(inputs: Account_Delivery_Whatsapp_Enabled_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp notifications`)
};

/**
* | output |
* | --- |
* | "WhatsApp notifications" |
*
* @param {Account_Delivery_Whatsapp_Enabled_LabelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_whatsapp_enabled_label = /** @type {((inputs?: Account_Delivery_Whatsapp_Enabled_LabelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Whatsapp_Enabled_LabelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_whatsapp_enabled_label(inputs)
	return en_account_delivery_whatsapp_enabled_label(inputs)
});